<template>
    <!--汇管-->
    <div class="tc5" v-show="jarShow">
        <div class="close" @click="changeShow"></div>
        <div class="tc5-box">
            <div class="tc5-top">
                <div class="top-list">
                    <div class="top-header">点名：{{activeObj.NAME || ''}}</div>

                </div>
                <div class="top-list">
                    <div class="top-header">点说明：{{activeObj.COMMENTS || ''}}</div>
                    <div class="top-end" style="font-size: 12px">当前值</div>
                </div>
            </div>
            <div class="tc5-middle">
                <div class="middle-list">
                    <P>单位：<span v-if="activeObj.PDI">kPa</span><span v-if="activeObj.PI">MPa</span></P>
                    <P v-if="activeObj.PDI">计差：<span>{{ activeObj.PDI || "0" }}</span></P>
                    <P v-if="activeObj.PI">压力：<span>{{ activeObj.PI || "0" }}</span></P>
                </div>
                <div class="middle-box" v-if="activeObj.PDIRH">
                    <p>计差 <span>计差量程上限：{{ activeObj.PDIRH || 0 }}</span></p>
                    <p>计压 <span>计压量程上限：{{ activeObj.PDIRL || 0 }}</span></p>
                </div>
                <div class="middle-box" v-if="activeObj.PIRH">
                    <p>压力 <span>压力上限：{{ activeObj.PIRH || 0 }}</span></p>
                    <p>压力 <span>压力下限：{{ activeObj.PIRL || 0 }}</span></p>
                </div>
            </div>
            <div class="tc5-bottom">
                <div class="bottom-list">
                    <P v-if="activeObj.PDI">电流 <span>电流mA值：{{activeObj.PDI}}</span></P>
                    <P v-if="activeObj.PIA">PIA <span>PIA值：{{activeObj.PIA}}</span></P>
                    <P>时间 <span>{{activeObj.time}}</span></P>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Jar",
    data() {
        return {
            activeObj: {},
            jarNmae: [ "smgdg7","smgdg6","smgdg5"],
            jarShow: false,
            path:''
        }
    },
    mounted() {
        window.getJar1 = this.getJar1;
        window.jarchangeShow = this.changeShow;

    },
    methods: {
        
        //获取点击的哪个罐子
        getJar1(type) {
            for (let i = 0; i < this.jarNmae.length; i++) {
                if (this.jarNmae[i] === type) {
                    this.path = '/pdi2'+(i+1)+'01';
                }
            }

            //获取数据
            // this.getDtat(this.path);
            this.jarShow = true;
        },
        //关闭弹窗
        changeShow() {
            this.jarShow = false;
        }
    }
}
</script>


<style scoped>
.close {
    position: absolute;
    width: 9px;
    height: 9px;
    background: url("./asses/close.png") no-repeat;
    background-size: 100% 100%;
    right: 19px;
    top: 4px;
    cursor: pointer;
}

.tc5 {
    z-index: 999;
    position: absolute;
    width: 426px;
    height: 225px;
    background: url("./asses/tc5.png") no-repeat;
    background-size: 100% 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
}

.tc5 .close {
    position: absolute;
    width: 9px;
    height: 9px;
    background: url("./asses/close.png") no-repeat;
    background-size: 100% 100%;
    right: 24px;
    top: 25px;
    cursor: pointer;
}

.tc5 .tc5-box {
    width: 376px;
    height: 166px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.tc5-top .top-list {
    width: 90%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
}

.tc5-top .top-list .top-header {
    font-size: 12px;
}

.tc5-top .top-list .top-end {
    font-size: 16px;
    color: #00ffea;
    font-weight: bold;
}

.tc5-middle {
    font-size: 12px;
    margin: 8px 0;
}

.tc5-middle .middle-list {
    width: 100%;
    height: 20px;
    background-color: rgb(0, 63, 80);
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 12px;
}

.tc5-middle .middle-list span {
    font-size: 12px;
    color: rgb(0, 255, 234);
}

.tc5-middle .middle-box {
    width: 100%;
    height: 42px;
    background-color: rgb(0, 63, 80);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.tc5-middle .middle-box p {
    width: 39%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgba(255, 255, 255, 0.502);
}

.tc5-middle .middle-box span {
    font-size: 12px;
    color: rgb(0, 255, 234);
    margin-left: 10px;
}

.bottom-list {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.bottom-list p {
    width: 90%;
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.502);
    position: relative;
}

.bottom-list p span {
    font-size: 12px;
    color: rgb(0, 255, 234);
    margin-left: 10px;
    position: absolute;
    white-space: nowrap;
}

.bottom-list p span:nth-last-of-type(2) {
    left: 10%;
}

.bottom-list p span:nth-last-of-type(1) {
    right: 10%;
}
</style>